import { editableRoadSegment, defaultEditableRoadSegment } from '../editableRoadSegment'

export function removeEditableRoadSegment() {
  editableRoadSegment.roadSegment = { ...defaultEditableRoadSegment }
}
